import { createContext, Dispatch, ReactNode, useReducer } from 'react';

import { MediaApiReducer, MediaStateReducer } from './reducers';
import { MediaElement, MediaElementActionPayload } from './types';

export interface MediaElementProviderProps {
  children: ReactNode;
}

const initialState: MediaElement = {
  mediaApi: undefined,
  mediaState: {
    audioTrackIndex: 0,
    audioTracks: [],
    canPlay: false,
    currentTime: 0,
    duration: 0,
    isMuted: false,
    isPaused: false,
    isPlaying: false,
    seeking: false,
    subtitleEnabled: false,
    textTracks: undefined,
    volume: 1.0,
  },
};

export const MediaElementContext = createContext<MediaElement>(initialState);
export const MediaElementDispatchContext =
  createContext<Dispatch<MediaElementActionPayload> | null>(null);

const rootReducer = (state: MediaElement, action: MediaElementActionPayload) => ({
  mediaApi: MediaApiReducer(state.mediaApi, action),
  mediaState: MediaStateReducer(state.mediaState, action),
});

export function MediaElementProvider({ children }: MediaElementProviderProps) {
  const [mediaState, dispatch] = useReducer(rootReducer, initialState);
  return (
    <MediaElementContext.Provider value={mediaState}>
      <MediaElementDispatchContext.Provider value={dispatch}>
        {children}
      </MediaElementDispatchContext.Provider>
    </MediaElementContext.Provider>
  );
}
